var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{staticClass:"item",attrs:{"to":_vm.url}},[_c('img',{staticClass:"item-img",attrs:{"alt":_vm.alt,"src":_vm.img || '',"width":"360px","height":"59px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }